/* eslint-disable class-methods-use-this */
import AbstractMapper from '@core/utils/mappers/AbstractMapper';
import { ISpecialTicketItemDto, ITicketItemDto } from './dtos/ISubmittingTicketDto';
import ISelection from '@core/models/betSlip/ISelection';
import SportSelectionMapper from './SportSelectionMapper';
import SpecialSelectionMapper from './SpecialSelectionMapper';
import SportSelection from '@core/models/betSlip/SportSelection';
import SpecialSelection from '@core/models/betSlip/SpecialSelection';

const sportBetSlipSelectionMapper: SportSelectionMapper = new SportSelectionMapper();
const specialSelectionMapper: SpecialSelectionMapper = new SpecialSelectionMapper();

export default class SelectionToTicketItemMapper
    extends AbstractMapper<ISelection, ITicketItemDto | ISpecialTicketItemDto> {
    createTargetObject(item: ISelection, propagatedAttributes: any): ITicketItemDto | ISpecialTicketItemDto {
        if (item instanceof SpecialSelection) {
            return specialSelectionMapper.createTargetObject(item);
        }

        if (item instanceof SportSelection) {
            return sportBetSlipSelectionMapper.createTargetObject(item, propagatedAttributes);
        }

        throw new Error('Invalid selection type.');
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/tickets/SelectionToTicketItemMapper.ts